import Maps from '@/pages/maps/Maps'
import store from '@/store/store'
import RoutesResolver from '@/support/routes-resolver'
import constants from '@/resources/constants'
import RouteUtils from '@/support/route-utils'
import appConfig from '@/config/app-config'
import termAndCondition from '../../fragments/sidebar/termsAndConditions.vue'
import PrivacyPolicy from '../../fragments/sidebar/privacyPolicy.vue'
import DataPage from '../../fragments/data-page/data-page.vue'
import LoginPage from '../../fragments/auth/login.vue'
import RegisterPage from '../../fragments/auth/register.vue'


const rootPath = RoutesResolver.homeUrl()
const placePath = RoutesResolver.place()
const directionsPath = RoutesResolver.directions()
const searchPath = RoutesResolver.search()
const isochronesPath = RoutesResolver.isochronesPath()
const embedParameters = '/:embed?/:locale?'

// Build the optional placesNames Path
var optionalPlaceNamesPath = ''
for (let index = 2; index <= appConfig.maxPlaceInputs; index++) {
  optionalPlaceNamesPath += `/:placeName${index}?`
}

const mapRoutes = [
  {
    path: '/',
    name: 'Maps',
    component: Maps,
    beforeEnter: (to, from, next) => {
      // The root route is being matched only
      //  when a more specific route is being loaded (MapPlace, MapDirections ...)
      // As this was causing a weird redirection we had to tell vue router to
      // go the target route in this case
      const currentPath = location.hash.replace('#', '')
      // Only load the root route if the cleanMap flag is true
      if (
        currentPath !== '' &&
        currentPath !== '/' &&
        currentPath !== rootPath &&
        !store.getters.cleanMap
      ) {
        // In case of loading root route, set the
        // default mode as place mode
        store.commit('mode', constants.modes.place)
        // Go to the child route
        next(currentPath)
      } else {
        // Otherwise load the root route
        next()
      }
    }
  },
  {
    path: `${placePath}:placeName/@:coordinates/data/:data${embedParameters}`,
    name: 'MapPlace',
    component: Maps,
    beforeEnter: (to, from, next) => {
      store.commit('mode', constants.modes.place)
      next()
    }
  },
  {
    // The maximum number of places/points of a route is 15. so, we can have 15 places more the data parameter that
    // contains the coordinates for all the places in que query encoded in base64 format
    // The minimum is one (because of round trip needs only one place)
    path: `${directionsPath}:placeName1${optionalPlaceNamesPath}/data/:data${embedParameters}`,
    name: 'MapDirections',
    component: Maps,
    beforeEnter: (to, from, next) => {
      RouteUtils.setDirectionsModeBasedOnRoute(to)
      next()
    }
  },
  {
    path: `${searchPath}:term/@:center/z/:zoom${embedParameters}`,
    name: 'MapSearch',
    component: Maps,
    beforeEnter: (to, from, next) => {
      store.commit('mode', constants.modes.search)
      next()
    }
  },
  {
    path: `${isochronesPath}:placeName1${optionalPlaceNamesPath}/data/:data${embedParameters}`,
    name: 'MapIsochrones',
    component: Maps,
    beforeEnter: (to, from, next) => {
      store.commit('mode', constants.modes.isochrones)
      next()
    }
  },
  {
    path: `${isochronesPath}`,
    name: 'MapIsochronesHome',
    component: Maps,
    beforeEnter: (to, from, next) => {
      store.commit('mode', constants.modes.isochrones)
      next()
    }
  },
  {
    path: '/settings',
    name: 'MapSettings',
    component: Maps,
    beforeEnter: (to, from, next) => {
      store.commit('mode', constants.modes.place)
      store.commit('openSettings', true)
      next()
    }
  },
  {
    path: '/about',
    name: 'MapAbout',
    component: Maps,
    beforeEnter: (to, from, next) => {
      store.commit('mode', constants.modes.place)
      store.commit('openAbout', true)
      next()
    }
  },
  {
    path: '/gira', 
    name: 'Mapsgira',
    component: Maps,
    beforeEnter: (to, from, next) => {
      store.commit('mode', constants.modes.place)
      next()
    }
  },
  {
    path: '/hotspotMap', 
    name: 'hotspotMap',
    component: Maps,
    beforeEnter: (to, from, next) => {
      store.commit('mode', constants.modes.place)
      next()
    }
  },
  {
    path: '/terms', 
    name: 'termAndCondition',
    component: termAndCondition,
    beforeEnter: (to, from, next) => {
      store.commit('mode', constants.modes.place)
      next()
    }
  },
  {
    path: '/privacyPolicy', 
    name: 'PrivacyPolicy',
    component: PrivacyPolicy,
    beforeEnter: (to, from, next) => {
      store.commit('mode', constants.modes.place)
      next()
    }
  },
  {
    path: '/data', 
    name: 'DataPage',
    component: DataPage,
    beforeEnter: (to, from, next) => {
      store.commit('mode', constants.modes.place)
      next()
    }
  },
  {
    path: '/login', 
    name: 'LoginPage',
    component: LoginPage,
    beforeEnter: (to, from, next) => {
      store.commit('mode', constants.modes.place)
      next()
    }
  },
  {
    path: '/register', 
    name: 'RegisterPage',
    component: RegisterPage,
    beforeEnter: (to, from, next) => {
      store.commit('mode', constants.modes.place)
      next()
    }
  }
]

export default mapRoutes
